export class FileDelete {
  constructor(
    public elementId: string,
    public deleteComplete: () => void) {
  }
}